export default __webpack_public_path__ + "0b385d0b23f974eefde181b5ae4b756c.png";